import {
    CLOSE_CUSTOMER_DISPLAY,
    type CustomerDisplayActionTypes,
    type CustomerDisplayState,
    HIDE_MISSING_PERMISSIONS,
    OPEN_CUSTOMER_DISPLAY,
    SHOW_MISSING_PERMISSIONS,
} from "../../Actions/CustomerDisplay/CustomerDisplayActions";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";
import { getOption, setOption } from "../../Utilities/Platform/Options/Options";

const PREVIOUSLY_OPEN_KEY = "_customer_display_open_status";

function CustomerDisplayReducer(
    state: CustomerDisplayState | undefined,
    action: ShopfrontActions<CustomerDisplayActionTypes>
): CustomerDisplayState {
    if(typeof state === "undefined") {
        return {
            visible           : getOption(PREVIOUSLY_OPEN_KEY) ? 1 : 0,
            missingPermissions: false,
        };
    }

    switch(action.type) {
        case OPEN_CUSTOMER_DISPLAY:
            setOption(PREVIOUSLY_OPEN_KEY, true);

            return {
                ...state,
                visible: state.visible + 1,
            };
        case CLOSE_CUSTOMER_DISPLAY:
            setOption(PREVIOUSLY_OPEN_KEY, false);

            return {
                ...state,
                visible: 0,
            };
        case SHOW_MISSING_PERMISSIONS:
            return {
                ...state,
                missingPermissions: true,
            };
        case HIDE_MISSING_PERMISSIONS:
            return {
                ...state,
                missingPermissions: false,
            };
        default:
            return state;
    }
}

export default CustomerDisplayReducer;
